<template>
  <div class="CapitalTable">
    <vxe-table
      :data="tableData"
      ref="CapitalxTable"
      border
      resizable
      show-overflow
      highlight-hover-row
      highlight-current-row
      :height="tableHeight"
      :show-footer="showfooter"
      @resizable-change="resizablechange"
      :footer-method="footerMethod"
      @cell-click="cellclick"
      :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'16px',height:'37px',padding:'0',fontWeight: 'bold'}"
      :footer-row-style="{ background:'#eef1f6',color:'#000',fontSize:'14px',height:'30px',padding:'0',}"
      :footer-cell-style="{ background:'#fff',color:'#000',fontSize:'14px',height:'30px',padding:'0',}"
    >
      <vxe-table-column type="index" align="center" width="60" fixed="left">
        <template v-slot:header="{ column }">
          <i
            class="el-icon-s-tools"
            style="color:#2594ff;font-size:18px"
            @click="tableConfigShow=true"
          ></i>
        </template>
        <template v-slot="{ column , rowIndex }">{{rowIndex+1 }}</template>
      </vxe-table-column>
      <vxe-table-column width="100" align="center" title="操作" fixed="left">
        <template v-slot="{row,rowIndex}">
          <el-button type="text" @click.native.prevent="addRow(rowIndex+1)">新增</el-button>
          <el-button type="text" @click.native.prevent="deleteRow(rowIndex)">移除</el-button>
        </template>
      </vxe-table-column>
      <template v-for="(item,index) in tableConfig">
        <vxe-table-column
          v-if="(item.Key=='FullName') && item.Show == true"
          :width="item.Width==''?'200':item.Width"
          fixed="left"
          align="center"
          :title="item.Rename"
          :field="item.Key"
          :key="index"
        >
          <template v-slot="{row,rowIndex}">
            <div class="input_box ub ub-ac">
              <input
                size="mini"
                type="text"
                class="input_styf"
                ref="Choice"
                autocomplete="off"
                :id="'x_'+rowIndex+'_y_'+index"
                v-model.lazy="row[item.Key]"
                @keydown.up="UpArrow(row,rowIndex,index,item.Key)"
                @keydown.enter="EnterArrow(row,rowIndex,index,item.Key)"
                @keydown.down="EnterArrow(row,rowIndex,index,item.Key)"
                @keydown.37="LeftArrow(row,rowIndex,index,item.Key)"
                @keydown.39="RightArrow(row,rowIndex,index,item.Key)"
                @dblclick="ChoiceClick"
                @blur="doblurs($event,row.AtypeId,rowIndex,item.Key,row[item.Key])"
                @focus="doFocul($event,row[item.Key])"
              />
              <span
                v-if="(item.Key=='FullName') && item.Show == true"
                class="cliclicon el-icon-more"
                @click="ChoiceClick"
              ></span>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          v-if="(item.Key!='FullName') && item.Show == true"
          align="center"
          :title="item.Rename"
          :field="item.Key"
          :key="index"
        >
          <template v-slot="{row,rowIndex}">
            <div class="input_box ub ub-ac">
              <input
                v-if="row.AtypeId !==''&& row.FullName !=='' && item.Show == true && item.Key=='Total'"
                size="mini"
                ref="Choice"
                :id="'x_'+rowIndex+'_y_'+index"
                type="text"
                class="input_styf"
                v-model.lazy="row[item.Key]"
                @focus="doFocul($event,row[item.Key])"
                @blur="doblur($event,row.AtypeId,rowIndex,item.Key,row[item.Key])"
                @keydown.up="UpArrow(row,rowIndex,index,item.Key)"
                @keydown.enter="EnterArrow(row,rowIndex,index,item.Key)"
                @keydown.down="EnterArrow(row,rowIndex,index,item.Key)"
                @keydown.37="LeftArrow(row,rowIndex,index,item.Key)"
                @keydown.39="RightArrow(row,rowIndex,index,item.Key)"
                @change.stop="row[item.Key]=row[item.Key].replace(/^[^\-\d]*([\-\d]?\d*(?:\.\d{0,6})?).*$/g, '$1')"
              />
              <input
                v-else-if="row.AtypeId !==''&& row.FullName !==''&& item.Show == true && ( item.Key=='Memo')"
                size="mini"
                ref="Choice"
                :id="'x_'+rowIndex+'_y_'+index"
                type="text"
                class="input_styf"
                v-model.lazy="row[item.Key]"
                @focus="doFocul($event,row[item.Key])"
                @keydown.up="UpArrow(row,rowIndex,index,item.Key)"
                @keydown.enter="EnterArrow(row,rowIndex,index,item.Key)"
                @keydown.down="EnterArrow(row,rowIndex,index,item.Key)"
                @keydown.37="LeftArrow(row,rowIndex,index,item.Key)"
                @keydown.39="RightArrow(row,rowIndex,index,item.Key)"
              />
              <!-- 
                @blur="doblur($event,row.AtypeId,rowIndex,item.Key,row[item.Key])" -->
              <div v-else class="only_show_div">{{row[item.Key]}}</div>
            </div>
          </template>
        </vxe-table-column>
      </template>
    </vxe-table>
    <!-- 科目选择弹出框 -->
    <!-- <SubjectsDialog :show.sync="seaechGoodsShow" @chooseBack="chooseBack" v-bind="$attrs" /> -->
    <SubjectTables
      :show.sync="seaechGoodsShow"
      @chooseBack="chooseBack"
      v-bind="$attrs"
      :textname="textname"
    />
    <HeaderElastic
      :show.sync="tableConfigShow"
      :tableData="tableConfigData"
      v-bind="$attrs"
      v-on="$listeners"
      @restoreDefault="restoreDefault"
    />
  </div>
</template>

<script>
import tool from "@/utils/tool.js";
export default {
  data() {
    return {
      Data: this.tableData, // 表格数据
      textname: "",
      tableConfig: this.tableConfigData, // 表头数据
      seaechGoodsShow: false, //科目选择框是否显示
      rowIndex: 0, // 当前高两行所在位置
      inputfocusindex: 0, // 当前聚焦输入框位置
      focusinputa: "",
      FullNameName: "",
      tableConfigShow: false, //是否显示表头配置弹出框
    };
  },
  props: {
    tableHeight: {
      type: String,
      default: window.innerHeight - 400 + "px",
    }, // 动态高度
    tableData: Array,
    tableConfigData: Array,
    showfooter: { type: Boolean, default: true }, // 是否允许显示合计
    footerNames: {
      type: Array,
      default: function () {
        return ["Total"];
      },
    }, // 需要合计的字段
  },
  methods: {
    doFocul(event, row) {
      if (row != "") {
        this.FullNameName = row;
      }
      event.currentTarget.select();
    },
    // 恢复默认
    restoreDefault(val) {
      this.tableConfig = val;
    },
    // 拖动表格
    resizablechange({ $columnIndex, column }) {
      let datas = [];
      this.tableConfigData.map((tiem) => {
        if (tiem.Show != false) {
          datas.push(tiem);
        }
      });
      if ($columnIndex - 2 > 0 || $columnIndex == 2) {
        let jparams = {
          user_id: tool.getLocal("userid"),
          session_id: tool.getLocal("sessionid"),
          Model: this.$attrs.pargam.Model,
          data: [
            {
              BaseNo: datas[$columnIndex - 2].BaseNo,
              Width: column.resizeWidth,
            },
          ],
        };
        this.request
          .post("/index/Settings/modify_function_fields", {
            jparams: JSON.stringify(jparams),
          })
          .then((res) => {})
          .catch((err) => {
            console.log(err);
          });
      }
    },
    // 新增某一行
    addRow(index) {
      this.$emit("addback", index);
      setTimeout(() => {
        this.$refs.CapitalxTable.setCurrentRow(this.tableData[index - 1]);
        this.$refs.CapitalxTable.scrollToRow(
          this.$refs.CapitalxTable.getCurrentRow()
        );
      }, 300);
    },
    // 移除某一行
    deleteRow(index) {
      this.$emit("deleteRow", index);
      setTimeout(() => {
        this.$refs.CapitalxTable.setCurrentRow(this.tableData[index - 1]);
        this.$refs.CapitalxTable.scrollToRow(
          this.$refs.CapitalxTable.getCurrentRow()
        );
      }, 300);
    },
    distinctObj(numberArr, ind) {
      let obj = "";
      for (var i of numberArr) {
        if (i.id == ind) {
          obj = i;
          return obj;
        }
      }
      return false;
    },
    //   单击单元格
    cellclick({ row, $rowIndex, column }, event) {
      console.log(row);
      this.rowIndex = $rowIndex;
      if (event.target.id == "" || event.target.id == undefined) {
        this.distinctObj(this.$refs.Choice, `x_${$rowIndex}_y_0`).focus();
        this.focusinputa = `x_${$rowIndex}_y_0`;
      } else {
        this.focusinputa = event.target.id;
      }
    },
    // 上键
    UpArrow(row, rowIndex, index, key) {
      return;
      this.highlightcurren(this.rowIndex);
      rowIndex = rowIndex - 1;
      if (
        this.distinctObj(this.$refs.Choice, `x_${rowIndex}_y_${index}`) !==
        false
      ) {
        this.distinctObj(this.$refs.Choice, `x_${rowIndex}_y_${index}`).focus();
        this.focusinputa = `x_${rowIndex}_y_${index}`;
      } else {
        if (
          this.distinctObj(this.$refs.Choice, `x_${rowIndex}_y_0`) !== false
        ) {
          this.distinctObj(this.$refs.Choice, `x_${rowIndex}_y_0`).focus();
          this.focusinputa = `x_${rowIndex}_y_0`;
        }
      }
    },
    // 下键
    DwArrow(row, rowIndex, index, key) {
      return;
      this.highlightcurrens(this.rowIndex);
      rowIndex = rowIndex + 1;
      if (
        this.distinctObj(this.$refs.Choice, `x_${rowIndex}_y_${index}`) !==
        false
      ) {
        this.distinctObj(this.$refs.Choice, `x_${rowIndex}_y_${index}`).focus();
        this.focusinputa = `x_${rowIndex}_y_${index}`;
      } else {
        if (
          this.distinctObj(this.$refs.Choice, `x_${rowIndex}_y_0`) !== false
        ) {
          this.distinctObj(this.$refs.Choice, `x_${rowIndex}_y_0`).focus();
          this.focusinputa = `x_${rowIndex}_y_0`;
        }
      }
    },
    // 按回车
    EnterArrow(row, rowIndex, index, key) {
      if (row.AtypeId == "" && index == 0) {
        if (row.FullName == "") {
          this.seaechGoodsShow = true;
        } else {
          this.textname = row.FullName;
          this.seaechGoodsShow = true;
        }
      } else {
        for (let i = index + 1; i < this.tableConfigData.length + 1; i++) {
          if (
            this.distinctObj(this.$refs.Choice, `x_${rowIndex}_y_${i}`) !==
            false
          ) {
            this.distinctObj(this.$refs.Choice, `x_${rowIndex}_y_${i}`).focus();
            this.focusinputa = `x_${rowIndex}_y_${i}`;
            return;
          }
          if (i + 1 === this.tableConfigData.length + 1) {
            this.highlightcurrens(this.rowIndex);
            rowIndex = rowIndex + 1;
            this.distinctObj(this.$refs.Choice, `x_${rowIndex}_y_0`).focus();
            this.focusinputa = `x_${rowIndex}_y_0`;
          }
        }
      }
    },
    // 左键
    LeftArrow(row, rowIndex, index, key) {},
    // 右键
    RightArrow(row, rowIndex, index, key) {},
    // 光标上移
    highlightcurren(dire) {
      if (dire - 1 != -1) {
        this.rowIndex = dire - 1;
        this.$refs.CapitalxTable.setCurrentRow(this.tableData[this.rowIndex]);
        this.$refs.CapitalxTable.scrollToRow(
          this.$refs.CapitalxTable.getCurrentRow()
        );
      }
    },
    // 光标下移
    highlightcurrens(dire) {
      if (dire + 1 != this.tableData.length) {
        this.rowIndex = dire + 1;
        this.$refs.CapitalxTable.setCurrentRow(this.tableData[this.rowIndex]);
        this.$refs.CapitalxTable.scrollToRow(
          this.$refs.CapitalxTable.getCurrentRow()
        );
      }
    },
    // 循环去重
    Duplicateremoval(arr) {
      var ars = arr;
      ars.map((item, i) => {
        if (item.$refs != undefined) {
          ars.splice(i, 0, item.$refs.input);
        }
      });
      for (let i = 0; i < ars.length; i++) {
        for (var j = i + 1; j < ars.length; j++) {
          if (ars[i].id == ars[j].id) {
            ars.splice(j, 1);
            j--;
          }
        }
      }
      return ars;
    },
    // 获取数组中指定元素的位置
    Arrlength(arr, dst, val = 1) {
      if (val == 0) {
        var i = 0;
        for (let index = 0; index < arr.length; index++) {
          const element = arr[index];
          if (element == dst) {
            i = index;
            return i;
          }
        }
        return false;
      } else {
        var i = 0;
        for (let index = 0; index < arr.length; index++) {
          const element = arr[index];
          if (element.id == dst) {
            i = index;
            return i;
          }
        }
        return false;
      }
    },
    //   合计
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (this.footerNames.includes(column.property)) {
            return this.sum(data, column.property);
          }
          return null;
        }),
      ];
    },
    sum(data, e) {
      let d = 0;
      data.map((item) => {
        if (item.AtypeId != "") {
          d += Number(item[e]);
        }
      });
      return Number(d).toFixed(tool.getLocal("get_config").moneyPoint);
    },
    // 商品名称
    doblurs(event, val, rowIndex, Key, name) {
      if (val === "") {
        event.srcElement.value = "";
        this.tableData[rowIndex][Key] = "";
      }
      if (val !== "") {
        this.tableData[rowIndex][Key] = this.FullNameName;
      }
    },
    doblur(event, val, rowIndex, Key, value) {
      console.log(Key);
      this.$refs.CapitalxTable.updateFooter();
      if (val == "") {
        event.srcElement.value = "";
        this.tableData[rowIndex][Key] = "";
      }
      if (Number(value)) {
        this.tableData[rowIndex][Key] = Number(value).toFixed(
          tool.getLocal("get_config").moneyPoint
        );
      }
    },
    // 科目数据回填
    chooseBack(data) {
      data.Memo = "";
      this.$emit("chooseBack", data, this.rowIndex);
    },
    // 条件查询  选中表格
    childAction() {
      // this.Duplicateremoval(this.$refs.Choice)[0].focus();
      this.distinctObj(this.$refs.Choice, `x_0_y_0`).focus();
      this.$refs.CapitalxTable.setCurrentRow(this.tableData[0]);
    },
    // 初始化数据
    loadList(size) {
      // this.loading = true;
      // setTimeout(() => {
      // let CapitalxTable = this.$refs.CapitalxTable;
      // if (CapitalxTable) {
      //   // 使用函数式加载，阻断 vue 对大数组的双向绑定，大数据性能翻倍提升
      //   CapitalxTable.reloadData(this.tableData).then(() => {
      //     this.loading = false;
      //   });
      // } else {
      //   this.loading = false;
      // }
      // }, 300);
    },
    // 选择资金
    ChoiceClick() {
      this.seaechGoodsShow = true;
    },
  },
  mounted() {
    this.loadList();
    this.$on("footer", (e) => {
      this.childAction();
    });
  },
  created() {},
  computed: {
    // 当前 tab 项的 name
    currentTabIndex() {
      return this.$store.getters.GetTabHash; //  window.location.pathname;
    },
  },
  watch: {
    currentTabIndex: {
      handler(newVal, oldVal) {
        let componentName = this.$tab.info().components[0].path;
        if (
          componentName == "increaseaccounts" ||
          componentName == "cashstatement" ||
          componentName == "generalcost" ||
          componentName == "generalrevenue" ||
          componentName == "increasedcope" ||
          componentName == "moneyflows" ||
          componentName == "paymentorder" ||
          componentName == "reduceaccounts" ||
          componentName == "reducecope" ||
          componentName == "voucherorder"
        ) {
          this.$refs.CapitalxTable.recalculate();
          return;
        }
      },
    },
    tableData: {
      handler(e, v) {
        this.loadList();
        this.$refs.CapitalxTable.updateFooter();
        this.$refs.CapitalxTable.updateData();
      },
    },
    tableConfigData: {
      handler(e, v) {
        this.tableConfig = e;
        this.loadList();
      },
    },
    seaechGoodsShow: {
      handler(e, v) {
        if (!e) {
          this.textname = "";
          setTimeout(() => {
            this.distinctObj(this.$refs.Choice, this.focusinputa).focus();
            this.$refs.CapitalxTable.setCurrentRow(
              this.tableData[this.rowIndex]
            );
            this.FullNameName = this.tableData[this.rowIndex].FullName;
          }, 200);
        }
      },
    },
  },
};
</script>

<style lang="less" scoped>
.cliclicon {
  position: absolute;
  top: 8px;
  right: 9px;
  // display: none;
}
.cliclicon:hover {
  color: #0881f3;
  cursor: pointer;
}
.only_show_div {
  width: 100%;
  height: 100%;
  line-height: 30px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.input_styf {
  height: 100%;
  width: 100%;
  display: block;
  position: relative;
  -webkit-box-flex: 1;
  box-flex: 1;
  padding: 0 !important;
  background: #fff;
  display: block;
  box-sizing: border-box;
  padding: 0 0;
  border: 0; //可根据需要修改有无边框显示长度和宽带
  overflow: hidden;
  // outline: none;
  text-align: center;
}

/deep/ .vxe-table .vxe-cell {
  padding: 0 !important;
}
/deep/ .vxe-table .vxe-body--column.col--ellipsis,
.vxe-table.vxe-editable .vxe-body--column,
.vxe-table .vxe-footer--column.col--ellipsis,
.vxe-table .vxe-header--column.col--ellipsis {
  height: 30px;
}
.el-button--medium {
  padding: 7px 0;
}
.el-select {
  width: 100%;
  /deep/ .el-input--mini .el-input__inner {
    height: 30px;
    line-height: 30px;
    border: 0; //可根据需要修改有无边框显示长度和宽带
    border-radius: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Table/CapitalTable/CapitalTable.vue